import React from 'react';
import { Link } from 'react-router-dom';
import { Project } from '../types';
interface ProjectCardProps {
  project: Project;
  showDescription?: boolean;
}
const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  showDescription = false
}) => {
  return <Link to={`/projects/${project.slug}`} className="group relative block w-full cursor-target" data-id="element-77">
      <div className="flex justify-between items-end mb-4 px-1" data-id="element-78">
        <div className="max-w-[85%]" data-id="element-79">
          <span className="text-[9px] text-zinc-500 uppercase tracking-[0.2em] block mb-2 font-extrabold" data-id="element-80">
            {project.year} — {project.category}
          </span>
          <h3 className="text-2xl md:text-[clamp(1.5rem,4vw,2.25rem)] font-extrabold tracking-tighter lowercase leading-tight group-hover:translate-x-1 transition-transform duration-500 [text-wrap:balance]" data-id="element-81">
            {project.title}
          </h3>
        </div>
        <div className="text-xl opacity-0 group-hover:opacity-100 transition-all duration-500 -translate-x-2 group-hover:translate-x-0" data-id="element-82">
          →
        </div>
      </div>
      <div className="relative aspect-video w-full overflow-hidden rounded-sm transition-all duration-700 shadow-2xl bg-zinc-900 border border-white/5" data-id="element-83">
        <img src={project.coverImage} alt={project.title} className="w-full h-full object-cover opacity-80 grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:opacity-100 transition-all duration-1000 ease-out" data-id="element-84" />
        {/* Subtle radial gradient to ground the image */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60 group-hover:opacity-0 transition-opacity duration-700 pointer-events-none" data-id="element-85" />
      </div>
      {showDescription && <p className="mt-6 text-zinc-400 text-sm md:text-base max-w-sm leading-relaxed font-medium" data-id="element-86">
          {project.description}
        </p>}
    </Link>;
};
export default ProjectCard;